import { HttpClient, HttpParams } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { GbFrontCookieService } from 'libs/gb-front/auth/util/src/lib/gb-front-cookie/gb-front-cookie.service'
import {
  BidPayload,
  CreateDonationResponse,
  CreateLiveBidResponse,
  CreatePurchaseResponse,
  CreateRafflePurchaseResponse,
  DonationPayload,
  LiveBidPayload,
  PurchasePayload,
  RafflePurchasePayload,
  ItemEntity,
} from './selected-item.models'
import { WinningBidEntity } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'

@Injectable({
  providedIn: 'root',
})
export class SelectedItemApiService extends GbBaseApiService {
  constructor(
    protected http: HttpClient,
    private gbFrontCookieService: GbFrontCookieService,
    @Inject(APP_CONFIG) protected appConfig: any,
  ) {
    super(http, appConfig)
  }

  /**
   * Get an item by its uuid
   */

  getItem(urlName: string, itemUuid: string | undefined): Observable<ItemEntity> {
    let withCredentials = false

    if (this.gbFrontCookieService.isVolunteer()) {
      withCredentials = true
    }

    const params = new HttpParams({ fromObject: { expand: true } })
    return this.get<ItemEntity>(`auctions/${urlName}/items/${itemUuid}/`, {
      params: params,
      withCredentials: withCredentials,
    })
  }

  /**
   * Send a bid object to the API
   * @param urlName
   * @param bid
   */

  createBid(urlName: string, bid: BidPayload): Observable<WinningBidEntity> {
    return this.post<WinningBidEntity>(`auctions/${urlName}/bids/`, bid)
  }

  createLiveBid(urlName: string, bid: LiveBidPayload): Observable<CreateLiveBidResponse> {
    return this.post<CreateLiveBidResponse>(`auctions/${urlName}/live-bids/`, bid)
  }

  /**
   * Send a donation object to the API
   * @param urlName
   * @param donation
   */

  createDonation(urlName: string, donation: DonationPayload): Observable<CreateDonationResponse> {
    return this.post<CreateDonationResponse>(`auctions/${urlName}/donations/`, donation)
  }

  /**
   * Send a purchase object to the API
   * @param urlName
   * @param purchase
   */

  createPurchase(urlName: string, purchase: PurchasePayload): Observable<CreatePurchaseResponse> {
    return this.post<CreatePurchaseResponse>(`auctions/${urlName}/purchases/`, purchase)
  }

  /**
   * Send a raffle purchase object to the API
   * @param urlName
   * @param rafflePurchase
   */

  createRafflePurchase(
    urlName: string,
    rafflePurchase: RafflePurchasePayload,
  ): Observable<CreateRafflePurchaseResponse> {
    return this.post<CreateRafflePurchaseResponse>(`auctions/${urlName}/raffle-purchases/`, rafflePurchase)
  }
}
